var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutPopupCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42C6.5 22.1178 22.6178 6 42.5 6C62.3823 6 78.5 22.1178 78.5 42C78.5 61.8823 62.3823 78 42.5 78C22.6178 78 6.5 61.8823 6.5 42Z",
    fill: "#F8C9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42C6.5 22.1178 22.6178 6 42.5 6C62.3823 6 78.5 22.1178 78.5 42C78.5 61.8823 62.3823 78 42.5 78C22.6178 78 6.5 61.8823 6.5 42Z",
    stroke: "#FDEDF0",
    strokeWidth: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5994 54C34.2812 54 33.9759 53.8736 33.7509 53.6485C33.5258 53.4235 33.3994 53.1183 33.3994 52.8V31.2C33.3994 30.8817 33.5258 30.5765 33.7509 30.3515C33.9759 30.1264 34.2812 30 34.5994 30H51.3994C51.7177 30 52.0229 30.1264 52.2479 30.3515C52.473 30.5765 52.5994 30.8817 52.5994 31.2V34.8H50.1994V32.4H35.7994V51.6H50.1994V49.2H52.5994V52.8C52.5994 53.1183 52.473 53.4235 52.2479 53.6485C52.0229 53.8736 51.7177 54 51.3994 54H34.5994ZM50.1994 46.8V43.2H41.7994V40.8H50.1994V37.2L56.1994 42L50.1994 46.8Z",
    fill: "#DF1C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutPopupCon);
export default __webpack_public_path__ + "static/media/signout-popup-con.31b4c6c70c649cf15cdb8d74275a1bf2.svg";
export { ForwardRef as ReactComponent };